import { render, staticRenderFns } from "./notifyDrivers.vue?vue&type=template&id=1ce929d2&scoped=true&"
import script from "./notifyDrivers.vue?vue&type=script&lang=js&"
export * from "./notifyDrivers.vue?vue&type=script&lang=js&"
import style0 from "./notifyDrivers.vue?vue&type=style&index=0&id=1ce929d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce929d2",
  null
  
)

export default component.exports